<template>
    <div class="article-chuck-about">
        <p>
            Chuck Brown gives so much to this community that he loves dearly. He cares for the individual as well as the
            events and WCS families around the world. Even after doing this for 20-plus years, he remains humble yet
            passionate and constantly seeks new understanding, lessons and inspiration from other pros and fellow
            dancers.
        </p>
        <p>
            Despite being a highly experienced chief judge, he strives to help dancers find their feet and be proud of
            every moment in their dance journeys and remind them it is not about the scores from others that define us.
        </p>
        <p>
            I am incredibly grateful for the support I get from Chuck, he took a chance on me, a ‘slightly’ erratic
            advanced dancer, and continues to ‘big me up’ in our workshops, calm me down and remind me of what’s
            important during the many times I get stressed or anxious, and pushes me each time we work together to
            become a better dancer and teacher.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleChuckAbout',
};
</script>
